import { render, staticRenderFns } from "./CustomerEditForm.vue?vue&type=template&id=b0722f92"
import script from "./CustomerEditForm.vue?vue&type=script&lang=js"
export * from "./CustomerEditForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditForm.vue?vue&type=style&index=0&id=b0722f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports